<template>
    <div style="display: flex; flex-direction: column;">
        <div style="position:relative; height:50px; background-color: #fff; position: relative; z-index: 2;">
            <div style="display: flex; position: fixed; z-index: 10; right: 0; align-items: center; gap: 20px; padding-right: 14px; padding-top: 16px;">
                <div @click="showSearch">
                    <img style="width: 20px;" :src="require('@/assets/img/search_gray2.png')" alt="">
                </div>
                <AlarmIcon></AlarmIcon>
            </div>
            <div style="margin-top: 14px;">
                <div style="text-align: center;">
                    <img style="width: 80px;" :src="require('@/assets/img/soccerhow_logo_text.png')" alt="">
                </div>
            </div>
        </div>
        <div style="flex:1; overflow-y: auto; position: relative; z-index: 1; display: flex; flex-direction: column;">
            <div style="display: flex; justify-content: flex-end; font-size: 14px; font-weight: 700; padding: 0 12px; position: relative; z-index: 2; background-color: #fff; margin-top: 12px;">
                <div style="display: flex; align-items: center; gap: 6px; border: 1px solid #dbdbdb; background-color: #f2f2f2; border-radius: 12px; padding: 4px 12px;">
                    <img v-if="isShowWeatherImg" style="width: 18px;" :src="require(`@/assets/img/${weatherImg}.png`)" alt="">
                    <div>{{ placeName }} {{ temperature }}°C {{ weathercode_label }}</div>
                </div>
            </div>
            <div ref="transformWrapper" style="flex: 1; display: flex; flex-direction: column; margin-top: 5px;">
                <div style="font-weight: 600; font-size: 32px; line-height: 42px; margin-top: 6px; padding: 0 24px;">
                    <div>{{ $GlobalStore.loginInfo().name }}님
                        <span style="font-weight: 900; font-size: 24px; color: var(--color-main);">{{ $GlobalStore.loginInfo().position ? $GlobalStore.loginInfo().position : '' }}</span>
                    </div>
                </div>
                <div style="margin-top: 10px; padding: 0 24px;">
                    <template v-if="first_member_trigger && member_trigger_sentence[first_member_trigger.trigger_type]">
                        <div style="font-weight: 500; color: #808080;">{{ member_trigger_sentence[first_member_trigger.trigger_type][0] }}</div>
                        <div style="font-weight: 500; color: #808080; margin-top: 8px;">{{ member_trigger_sentence[first_member_trigger.trigger_type][1] }}</div>
                    </template>
                    <template v-else>
                        <div style="font-weight: 500; color: #808080;">사커하우 입단을 환영해요! ⚽️</div>
                        <div style="font-weight: 500; color: #808080; margin-top: 8px;">내 포지션에 딱 맞는 훈련부터 시작해볼까요?</div>
                    </template>
                </div>
                <div style="flex: 1; align-items: center;" :style="{display: is_image_loaded && is_member_trigger_loaded ? 'flex' : 'none'}">
                    <img style="width: 100%; height: auto; object-fit: cover;" :src="require('@/assets/ai_gif/' + aiGifSrc + '.gif')" alt="" @load="onImageLoad">
                </div>
            </div>
            <div v-show="is_image_loaded && is_member_trigger_loaded">
                <div style="padding-bottom: 28px;">
                    <div style="padding: 0 24px;">
                        <div style="font-weight: 500; font-size: 15px; line-height: 24px; color: #808080;">지금 하면 좋은 활동을 골라봤어요!</div>
                        <div @touchmove.stop="() => { }" style=" margin-top: 15px;">
                            <HomeBottomModalList :member_triggers="member_triggers"></HomeBottomModalList>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PopupBanner v-show="popupBanners.length > 0" :isShowPopupBanner="isShowPopupBanner" :banners="popupBanners" :hide="() => { isShowPopupBanner = false }"></PopupBanner>
        <div style="flex-shrink: 0; position: relative; z-index: 200;">
            <PageBottom />
            <AfterFindPositionPopup :btnClickEvent="addFeed" :popupType="AFTER_POSITION_POPUP_TYPE.SOCCER_JOIN"></AfterFindPositionPopup>
            <LearnSoccerWriteForm :refresh="completeAction" :isShowWriteForm="isShowWriteForm" :closeWriteForm="closeWriteForm" :formType="FORM_TYPE.SKILL" ></LearnSoccerWriteForm>
        </div>
    </div>
</template>

<script>
import {TRIGGER_TYPE} from "../../Constants";
import PopupBanner from '@/components/common/PopupBanner'
const FORM_TYPE = {
    TOPIC: 'TOPIC',
    SKILL: 'SKILL'
}

import AlarmIcon from '@/components/common/AlarmIcon'
import PageBottom from '@/components/common/PageBottom'
import { PAGE_NAME, AFTER_POSITION_POPUP_TYPE, MAIN_TYPE, HOME_POPUP_TODAY_CLOSE_DATE,  } from '@/Constants'
import GpsManager from "@/modules/GpsManager";
import Weather from '@/modules/Weather'
import HomeBottomModalList from '@/components/common/HomeBottomModalList'
import AfterFindPositionPopup from '@/components/common/AfterFindPositionPopup'
import LearnSoccerWriteForm from '@/components/soccerhowmain/LearnSoccerWriteForm'
import moment from 'moment';
export default {
    components: {
        AlarmIcon,
        PageBottom,
        HomeBottomModalList,
        AfterFindPositionPopup,
        LearnSoccerWriteForm,
        PopupBanner
    },
    name: 'AiHome',
    data() {
        return {
            MAIN_TYPE: MAIN_TYPE,
            AFTER_POSITION_POPUP_TYPE: AFTER_POSITION_POPUP_TYPE,
            FORM_TYPE: FORM_TYPE,
            temperature: 0,
            weathercode: 0,
            weathercode_label: '',
            popupBanners: [],
            placeName: '',
            sheetTranslateY: 0,
            sheetOpenTranslateY: -200,
            isShowWeatherImg: false,
            touchStartY: 0,
            isShowPopupBanner: false,
            touchStartTranslate: 0,
            aiGifSrc: '',
            isShowWriteForm: false,
            weatherImg: '',
            member_triggers : [],
            is_member_trigger_loaded : false,
            is_image_loaded : false,
            first_member_trigger : null,
            member_trigger_sentence : {
                [TRIGGER_TYPE.RETURNING_USER] : ['돌아오셨군요! 🏃‍♂️ ', '쉬는 동안 굳은 몸, 가벼운 훈련 영상으로 풀어봐요.'],
                [TRIGGER_TYPE.NEW_SIGNUP] : ['사커하우 입단을 환영해요! ⚽️', '내 포지션에 딱 맞는 훈련부터 시작해볼까요?'],
                [TRIGGER_TYPE.NEW_SIGNUP_TRAINING] : ['사커하우 입단을 환영해요! ⚽️', '내 포지션에 딱 맞는 훈련부터 시작해볼까요?'],
                [TRIGGER_TYPE.NEW_SIGNUP_REQUEST] : ['사커하우 입단을 환영해요! ⚽️', '내 포지션에 딱 맞는 훈련부터 시작해볼까요?'],
                [TRIGGER_TYPE.NEW_SIGNUP_POSITION] : ['사커하우 입단을 환영해요! ⚽️', '내 포지션에 딱 맞는 훈련부터 시작해볼까요?'],
                [TRIGGER_TYPE.NEW_SIGNUP_SOCCER] : ['사커하우 입단을 환영해요! ⚽️', '내 포지션에 딱 맞는 훈련부터 시작해볼까요?'],

                [TRIGGER_TYPE.JOIN_FORM_LEAVE] : ['쓰다 만 신청서가 있어요. 😢', '마저 작성하고 스카우트 제안을 받아보세요!'],
                [TRIGGER_TYPE.JOIN_APPLY_ATTEMPT_UNVERIFIED] : ['감독님 눈에 띄려면 신뢰가 생명! ', '‘부모님 인증’을 하면 연락 확률이 3배 늘어납니다.'],
                [TRIGGER_TYPE.AFTER_UPLOAD_FEEDBACK] : ['방금 올린 영상, 전문가에게 피드백 받아보세요. 🤝', '전문가의 코칭 한 번이면 실력이 확 달라질 수 있어요!'],
                [TRIGGER_TYPE.SCOUT_OFFER_ARRIVED] : ['드디어 감독님의 러브콜이 도착했습니다! 💌 ', '어떤 팀인지 확인해볼까요?'],

                [TRIGGER_TYPE.EXPERT_APPROVAL_AFTER] : ['환영합니다, 감독님! 🤝', '어플을 한번 둘러볼까요?'],
                [TRIGGER_TYPE.EXPERT_APPROVAL_AFTER_MEMBERSHIP] : ['환영합니다, 감독님! 🤝', '어플을 한번 둘러볼까요?'],
                [TRIGGER_TYPE.EXPERT_APPROVAL_AFTER_FEEDBACK] : ['환영합니다, 감독님! 🤝', '어플을 한번 둘러볼까요?'],
                [TRIGGER_TYPE.EXPERT_APPROVAL_AFTER_AUTH] : ['환영합니다, 감독님! 🤝', '어플을 한번 둘러볼까요?'],
                [TRIGGER_TYPE.EXPERT_APPROVAL_AFTER_REGIST] : ['환영합니다, 감독님! 🤝', '어플을 한번 둘러볼까요?'],

                [TRIGGER_TYPE.JOIN_APPLICATION_ARRIVED] : ['똑똑똑! 🚪 우리 팀 입단을 희망하는 선수가 도착했어요.', '바로 확인해보세요!'],

                [TRIGGER_TYPE.EXPERT_TEAM_REGIST] : ['이적시장에 많은 선수들이 입단을 원하고 있습니다!', '지금 바로 팀 등록을 진행해보세요.'],

            }
        }
    },
    computed: {
        isExpert() {
            if (this.$GlobalStore.loginInfo() && this.$GlobalStore.loginInfo().is_temp_coach === '1') {
                return true
            } else {
                return false
            }
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.updateSheetOpenTranslate();
        });
        window.addEventListener('resize', () => {
            this.adjustGrayBoxHeight();
            this.updateSheetOpenTranslate();
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateSheetOpenTranslate);
    },
    methods: {
        async getHomeData() {
            const parameters = {}
            parameters.is_coach = this.isExpert
            parameters.page_type = 'home'
            const res = await this.$Axios.get('/api/home', { params: parameters });
            this.popupBanners = res.data.popup_banners || [];

            this.checkPopupBanner();
        },
        checkPopupBanner() {
            this.isShowPopupBanner = true;
            if (this.$hasOwnProperty(localStorage, HOME_POPUP_TODAY_CLOSE_DATE)) {
                const today = moment().format('YYYY-MM-DD');
                if (today === localStorage.getItem(HOME_POPUP_TODAY_CLOSE_DATE)) this.isShowPopupBanner = false;
            }
        },
        test() {
            this.$GlobalStore.setIsShowMemberInfoPopup(true)
        },
        completeAction(isSave, soccerhowIdx) {
            this.$router.push({ path: '/view/soccer_learn' + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
            this.$GlobalStore.addModal('TrainingRequestDetail', { main_type: MAIN_TYPE.SOCCER_LEARN, isModalBackTransparent: true, isExpert: false, soccerhowIdx: soccerhowIdx })
        },
        addFeed(isHopeToBeSoccerPlayer) {
            if (isHopeToBeSoccerPlayer) {
                this.$GlobalStore.addModal('SelectPlayerType')
            } else {
                this.isShowWriteForm = true
            }
        },
        closeWriteForm() {
            this.isShowWriteForm = false
        },
        showMyPosition() {
            if (!this.$GlobalStore.loginInfo().position_pro_ability) {
                this.$GlobalStore.addModal('FindPositionLite', { isShowDirectResult: true, memberPosition: this.$GlobalStore.loginInfo().position })
                return
            } else {
                this.$GlobalStore.addModal('FindPositionProResult', { positionsArr: this.$GlobalStore.loginInfo().position_pro_ability, groupedData: this.$GlobalStore.loginInfo().position_pro_ability })
            }
        },
        onImageLoad() {
            this.is_image_loaded = true;
            this.executeAfterLoading();
        },
        executeAfterLoading(){
            if( !(this.is_image_loaded && this.is_member_trigger_loaded)){
                return
            }

            this.$nextTick(() => {
                this.adjustGrayBoxHeight();
            });
        },
        adjustGrayBoxHeight() {
            // if (!this.$refs.floatAnimation || !this.$refs.grayBox) return;

            // const floatAnimationRect = this.$refs.floatAnimation.getBoundingClientRect();
            // const currentBottom = floatAnimationRect.bottom;
            // const targetBottom = window.innerHeight + 88;
            // const difference = targetBottom - currentBottom;

            // const currentHeight = this.$refs.grayBox.offsetHeight || 0;
            // const newHeight = currentHeight + difference - this.$GlobalStore.navigationBarHeight()

            // this.$refs.grayBox.style.height = Math.max(0, newHeight) + 'px';
        },
        updateSheetOpenTranslate() {
            if (!this.$refs.grayBox || !this.$refs.transformWrapper) return;
            this.sheetOpenTranslateY = -152
            if (this.sheetTranslateY < 0) {
                this.sheetTranslateY = this.sheetOpenTranslateY;
            }
        },
        showSearch() {
            let pageName = '';
            pageName = PAGE_NAME.SOCCER_TEAM;
            this.$Util.sendEventClick('홈_검색아이콘_클릭', true)
            this.$GlobalStore.addModal('IntergrationSearch', { pageName: pageName })
        },
        onSheetTouchStart(e) {
            this.touchStartY = e.touches[0].clientY;
            this.touchStartTranslate = this.sheetTranslateY;
        },
        onSheetTouchMove(e) {
            const deltaY = e.touches[0].clientY - this.touchStartY;
            let next = this.touchStartTranslate + deltaY;
            next = Math.max(this.sheetOpenTranslateY, Math.min(0, next));
            this.sheetTranslateY = next;
            if (next !== 0 && next !== this.sheetOpenTranslateY && e.cancelable) {
                e.preventDefault();
            }
        },
        onSheetTouchEnd() {
            const threshold = this.sheetOpenTranslateY / 2;
            this.sheetTranslateY = this.sheetTranslateY < threshold ? this.sheetOpenTranslateY : 0;
        },
        pickAiGif() {
            const info = this.$GlobalStore.loginInfo()
            const isTemp = info && info.is_temp_coach == 1
            const pool = isTemp
                ? ['coach_1', 'coach_2', 'coach_3']
                : ['player_1', 'player_2', 'player_3', 'player_4', 'player_5', 'coach_1', 'coach_2', 'coach_3']
            const idx = Math.floor(Math.random() * pool.length)
            this.aiGifSrc = pool[idx]
        },
        async getTriggers(){
            const res = await this.$Axios.get('/api/member/trigger/list');
            this.member_triggers = res.data.member_triggers;
            this.is_member_trigger_loaded = true;
            if(res.data.member_triggers.length > 0){
                this.first_member_trigger = res.data.member_triggers[0];
            }else {
                this.first_member_trigger = null;
            }
            this.executeAfterLoading();
        },
        setWetherImg() {
            const code = Number(this.weathercode)
            switch (true) {
                case code === 0 || code === 1 || code === 2:
                    return 'sunny'
                case code === 3 || code === 45 || code === 48:
                    return 'cloud'
                case (code >= 71 && code <= 77):
                    return 'snow'
                case (
                    code === 51 || code === 53 || code === 55 ||
                    code === 61 || code === 63 || code === 65 ||
                    code === 66 || code === 67 ||
                    (code >= 80 && code <= 99)
                ):
                    return 'rainy'
                default:
                    return 'sunny'
            }
        }
    },
    async created() {
        this.pickAiGif()
        if (process.env.NODE_ENV === 'production') {
            this.device_gps_location = await GpsManager.getLocation()
        } else {
            this.device_gps_location = { latitude: '34.473627', longitude: '127.009505' }
        }

        this.getTriggers();
        this.getHomeData();
        const result = await Weather.getWeatherAndPlace(this.device_gps_location)
        if (result) {
            this.placeName = result.placeName
            this.temperature = result.temperature
            this.weathercode = result.weathercode
            this.weathercode_label = result.weathercode_label
            this.weatherImg = this.setWetherImg()
            this.isShowWeatherImg = true
        }

    }
}
</script>

<style scoped>
.welcome_gradient {
    background: linear-gradient(90deg, #FF7111 34.62%, #F6B200 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-size: 40px;
    line-height: 50px;
    font-weight: 700;
}

.float-animation {
    animation: floatUpDown 2.5s ease-in-out infinite;
}

@keyframes floatUpDown {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-10px);
    }
}
</style>
